import { localize } from "utils/localizer";

const i18n = {
    account: {
        en: "Account",
        de: "Nutzerkonto",
    },
    aliasAccounts: {
        en: "Alias accounts",
        de: "Alias-Accounts",
    },
    aliasDesc: {
        en: (alias: string, main: string) => `The alias account address will be ${alias}. The login data and all mails will be forwarded to ${main}.`,
        de: (alias: string, main: string) => `Die Alias-Account Adresse lautet ${alias}. Die Zugangsdaten sowie alle E-Mails werden an ${main} weitergeleitet.`,
    },
    aliasNonClub: {
        en: "The creation of alias accounts is only relevant for the dashboard use through club members.",
        de: "Das Erstellen von Alias-Accounts ist nur für Vereinsmitglieder zur Nutzung des Dashboards relevant.",
    },
    aliasEmailChange: {
        en: "By changing the e-mail, this account will be converted into a normal account. Login via PIN is no longer possible and a new password needs to be requested via \"Forgot password\".",
        de: "Durch Ändern der E-Mail wird dieses Konto in ein normales Konto überführt. Anmelden über PIN ist dann nicht mehr möglich und ein neues Passwort muss über \"Passwort vergessen\" angefordert werden.",
    },
    allow3rdPartyCheckIns: {
        en: "Allow check-ins by third parties (e.g., the coach of an event)",
        de: "Erlaube Einchecken durch Dritte (z.B. der Coach eines Events)",
    },
    anErrorOccurred: {
        en: "An error occurred",
        de: "Ein Fehler ist aufgetreten",
    },
    birthday: {
        en: "Birthday",
        de: "Geburtsdatum",
    },
    cancel: {
        en: "Cancel",
        de: "Abbrechen",
    },
    change: {
        en: "Change",
        de: "Ändern",
    },
    changeEmailAddress: {
        en: "Change E-Mail Address",
        de: "E-Mail Adresse ändern",
    },
    changeEmailAddressCodeSent: {
        en: "Please provide the code we sent you to confirm your new e-mail address.",
        de: "Bitte gib den dir zugeschickten Code ein, um deine neue E-Mail Adresse zu bestätigen.",
    },
    changePassword: {
        en: (isAlias: boolean) => `Change ${isAlias ? "PIN" : "Password"}`,
        de: (isAlias: boolean) => `${isAlias ? "PIN" : "Passwort"} ändern`,
    },
    checkIn: {
        en: "Check-in",
        de: "Einchecken",
    },
    city: {
        en: "City",
        de: "Stadt",
    },
    code: {
        en: "Code",
        de: "Code",
    },
    competitions: {
        en: "Competitions",
        de: "Competitions",
    },
    currentPassword: {
        en: (isAlias: boolean) => `Current ${isAlias ? "PIN" : "password"}`,
        de: (isAlias: boolean) => `Aktuelle${isAlias ? "r PIN" : "s Passwort"}`,
    },
    changePasswordErrors: {
        en: {
            InvalidParameterException: "Incorrect password.",
            NotAuthorizedException: "Incorrect password.",
            passwordPolicy: "The password needs to be at least 6 characters long and must contain uppercase letters.",
            passwordsDontMatch: "Passwords do not match.",
            pinPolicy: "The PIN needs to consist of 4 digits.",
        },
        de: {
            InvalidParameterException: "Passwort ungültig.",
            NotAuthorizedException: "Passwort ungültig.",
            passwordPolicy: "Das Passwort muss mindestens 6 Zeichen lang sein, davon mindestens ein Großbuchstabe.",
            passwordsDontMatch: "Passwörter stimmen nicht überein.",
            pinPolicy: "Der PIN muss aus 4 Ziffern bestehen.",
        },
    },
    createAliasAccount: {
        en: "Create Alias Account",
        de: "Alias-Account erstellen",
    },
    deleteAccount: {
        en: "Delete Account",
        de: "Konto löschen",
    },
    deleteAccountDesc: {
        en: "This deletes your account irrevocably including all associated data. You will loose access to all PLAYSPORTS functionality. Your upcoming bookings are not cancelled, but your data will be anonymized.",
        de: "Dein Konto wird inklusive aller dazugehörigen Daten unwiderruflich gelöscht. Du verlierst Zugang zu allen PLAYSPORTS Funktionen. Deine anstehenden Buchungen werden nicht storniert, aber deine Daten anonymisiert.",
    },
    deleteAccountSuccess: {
        en: "Account deleted successfully",
        de: "Konto erfolgreich gelöscht",
    },
    deleteIrrevocably: {
        en: "Delete irrevocably",
        de: "Unwiderruflich löschen",
    },
    editContactData: {
        en: "Edit Contact Data",
        de: "Kontaktdaten bearbeiten",
    },
    email: {
        en: "E-Mail",
        de: "E-Mail",
    },
    emailAddress: {
        en: "E-Mail Address",
        de: "E-Mail Adresse",
    },
    emailPrefix: {
        en: "E-Mail address prefix",
        de: "E-Mail Adresse Präfix",
    },
    exportAllUserData: {
        en: "Export all user data",
        de: "Alle Nutzerdaten exportieren",
    },
    favoriteSportForms: {
        en: "Favorite sport forms",
        de: "Lieblingssportarten",
    },
    fileTooLarge: {
        en: "The file size may not exceed 3 MB",
        de: "Die Datei darf nicht größer als 3 MB sein",
    },
    firstName: {
        en: "First name",
        de: "Vorname",
    },
    forYou: {
        en: "For you",
        de: "Für dich",
    },
    fullName: {
        en: "Full name",
        de: "Vollständiger Name",
    },
    gender: {
        en: "Gender",
        de: "Geschlecht",
    },
    genders: {
        en: {
            male: "Male",
            female: "Female",
            diverse: "Diverse",
            none: "None",
        },
        de: {
            male: "Männlich",
            female: "Weiblich",
            diverse: "Divers",
            none: "Keine Angabe",
        },
    },
    lastName: {
        en: "Last name",
        de: "Nachname",
    },
    linkWithClub: {
        en: "Link with my location",
        de: "Meiner Sportstätte zuordnen",
    },
    linkWithUser: {
        en: "Link with my user profile",
        de: "Meinem Benutzerprofil zuordnen",
    },
    name: {
        en: "Name",
        de: "Name",
    },
    newBooking: {
        en: "New booking / invitation or when booking has changed",
        de: "Neue Buchung / Einladung oder bei Änderung einer Buchung",
    },
    newEmailAddress: {
        en: "New e-mail address",
        de: "Neue E-Mail Adresse",
    },
    newFollower: {
        en: "New follower",
        de: "Neuer Follower",
    },
    newPassword: {
        en: (isAlias: boolean) => `New ${isAlias ? "PIN" : "password"}`,
        de: (isAlias: boolean) => `Neue${isAlias ? "r PIN" : "s Passwort"}`,
    },
    newPasswordConfirm: {
        en: (isAlias: boolean) => `Confirm new ${isAlias ? "PIN" : "password"}`,
        de: (isAlias: boolean) => `Neue${isAlias ? "n PIN" : "s Passwort"} bestätigen`,
    },
    newStoryOrComment: {
        en: "New story / comment",
        de: "Neue Story / Kommentar",
    },
    newsletter: {
        en: "PLAYSPORTS newsletter",
        de: "PLAYSPORTS Newsletter",
    },
    notice3rdPartyContactDataRequired: {
        en: "To use this function for COVID-19 contact tracing, all above fields must be filled.",
        de: "Zur Nutzung dieser Funktion im Rahmen der COVID-19 Kontakterfassung müssen alle obigen Felder ausgefüllt sein.",
    },
    notifications: {
        en: "Notifications",
        de: "Benachrichtigungen",
    },
    ok: {
        en: "Ok",
        de: "Ok",
    },
    personalData: {
        en: "Personal Data",
        de: "Persönliche Daten",
    },
    postalCode: {
        en: "Postal code",
        de: "Postleitzahl",
    },
    privacy: {
        en: "Privacy",
        de: "Datenschutz",
    },
    privacyPolicy: {
        en: "Privacy Policy",
        de: "Datenschutzerklärung",
    },
    profileVisibility: {
        en: "Profile Visibility",
        de: "Profilsichtbarkeit",
    },
    profileVisibilities: {
        en: {
            private: "Private",
            "clubs-only": "Location",
            public: "Public",
            "public-inviteable": "Social",
        },
        de: {
            private: "Privat",
            "clubs-only": "Sportstätte",
            public: "Öffentlich",
            "public-inviteable": "Social",
        },
    },
    profileVisibilitiesForCompany: {
        en: {
            private: "Private",
            "clubs-only": "Group",
            public: "Public",
            "public-inviteable": "Social",
        },
        de: {
            private: "Privat",
            "clubs-only": "Gruppe",
            public: "Öffentlich",
            "public-inviteable": "Social",
        },
    },
    profileVisibilitiesDesc: {
        en: {
            private: "Your profile is visible to nobody. Your activities are shared with your followers and booking participants.",
            "clubs-only": "Your profile is visible to location members only. Your activities are shared with location members, your followers and booking participants.",
            public: "Your profile and your activities are visible to all PLAYSPORTS users. Only location members and your followers can invite you to activities.",
            "public-inviteable": "Your profile and your activities are visible to all PLAYSPORTS users. Everyone can invite you to activities.",
        },
        de: {
            private: "Niemand kann dein Profil sehen. Deine Aktivitäten werden mit deinen Followern und Buchungsteilnehmern geteilt.",
            "clubs-only": "Nur Sportstätten-Mitglieder können dein Profil sehen. Deine Aktivitäten werden mit Sportstätten-Mitgliedern, deinen Followern und Buchungsteilnehmern geteilt.",
            public: "Alle PLAYSPORTS Nutzer können dein Profil und deine Aktivitäten sehen. Nur Sportstätten-Mitglieder und deine Follower können dich zu Aktivitäten einladen.",
            "public-inviteable": "Alle PLAYSPORTS Nutzer können dein Profil und deine Aktivitäten sehen. Jeder kann dich zu Aktivitäten einladen.",
        },
    },
    push: {
        en: "Push",
        de: "Push",
    },
    remove: {
        en: "Remove",
        de: "Entfernen",
    },
    save: {
        en: "Save",
        de: "Speichern",
    },
    savedSuccessfully: {
        en: "Saved successfully",
        de: "Erfolgreich gespeichert",
    },
    security: {
        en: "Security",
        de: "Sicherheit",
    },
    signOut: {
        en: "Sign Out",
        de: "Abmelden",
    },
    status: {
        en: "Status",
        de: "Status",
    },
    statusPlaceholder: {
        en: "What's happening?",
        de: "Was machst du gerade?",
    },
    street: {
        en: "Street and house number",
        de: "Straße und Hausnummer",
    },
    telephoneCountryCode: {
        en: "Telephone country code",
        de: "Landesvorwahl",
    },
    telephoneNumber: {
        en: "Telephone number",
        de: "Telefonnummer",
    },
    termsOfService: {
        en: "Terms of Service",
        de: "Nutzungsbedingungen",
    },
    userProfile: {
        en: "User Profile",
        de: "Benutzerprofil",
    },
    insufficientNumberOfSeatsInCompanyError: {
        en: (associated: any) => `Your company has purchased an insufficient number of seats for this action. You have purchased ${associated.allowedNumMembers} seat(s) and there are currently ${associated.currentNumMembers} member(s).`,
        de: (associated: any) => `Dein Unternehmen hat nicht genügend Plätze für diese Aktion bezahlt. Du hast für ${associated.allowedNumMembers} Plätze bezahlt und es gibt aktuell ${associated.currentNumMembers} Mitglieder.`,
    },
};

export default localize(i18n);
